import { render } from "./Admin.vue?vue&type=template&id=14cf50c0&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=14cf50c0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-14cf50c0"

export default script